import { useState } from 'react';
import type { ImportProjectsResult } from '@wd/shared';
import { errorText } from '../../lib/api';
import { useImportProjects } from '../../lib/queries';
import { readTextFile } from '../../lib/textFile';
import { Icon } from '../../ui/icons';
import { Button, Modal } from '../../ui/primitives';
import './projectForm.css';

// 管理员批量导入项目：粘贴或选择 CSV，导入后列出新建的项目和跳过的行

const SAMPLE = '名称,负责人,参与人,团队,客户,截止日期,状态\n德国 EMS 认证,张工,陈工、孙工,研发中心,TÜV 南德,2026-12-31,进行中\n澳洲经销商培训,李经理,,销售部,,,未开始';

export function ProjectImportModal({ onClose }: { onClose: () => void }) {
  const run = useImportProjects();
  const [csv, setCsv] = useState('');
  const [result, setResult] = useState<ImportProjectsResult | null>(null);
  const [error, setError] = useState<string | null>(null);

  return (
    <Modal
      width={600}
      title="导入项目"
      subtitle="每行一个项目：名称,负责人,参与人,团队,客户,截止日期,状态"
      onClose={onClose}
      footNote={!result && '负责人和参与人会收到一条汇总通知，日报从现在起按项目预填'}
      footer={
        result ? (
          <Button variant="primary" onClick={onClose}>
            完成
          </Button>
        ) : (
          <Button
            variant="primary"
            disabled={!csv.trim() || run.isPending}
            onClick={() => {
              setError(null);
              run.mutate(csv, { onSuccess: setResult, onError: (e) => setError(errorText(e)) });
            }}
          >
            {run.isPending ? '正在导入…' : '导入'}
          </Button>
        )
      }
    >
      {result ? (
        <div className="pf-form">
          <div className="t-body">
            新建 {result.created.length} 个项目{result.skipped.length ? `，跳过 ${result.skipped.length} 行` : ''}。
          </div>
          {result.created.length > 0 && (
            <div className="pf-import-list">
              {result.created.map((p) => (
                <div key={p.code}>
                  <span className="t-meta">{p.code}</span> {p.name}
                </div>
              ))}
            </div>
          )}
          {result.skipped.length > 0 && (
            <div className="pf-import-list">
              {result.skipped.map((s) => (
                <div key={s.line} className="c3">
                  第 {s.line} 行：{s.reason}
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className="pf-form">
          <textarea className="wd-textarea" rows={9} value={csv} onChange={(e) => setCsv(e.target.value)} placeholder={SAMPLE} style={{ fontFamily: 'inherit' }} />
          <label className="pf-file">
            <Icon name="clip" size={14} />
            从文件读取（.csv，可以直接用 Excel 另存为 CSV）
            <input
              type="file"
              accept=".csv,text/csv,text/plain"
              onChange={(e) => {
                const f = e.target.files?.[0];
                if (f) void readTextFile(f).then(setCsv);
              }}
            />
          </label>
          <span className="t-meta">
            负责人、参与人写在职成员的姓名或邮箱，多个参与人用顿号隔开；团队要先在设置里建好；状态写未开始、进行中、阻塞、已完成或已取消，不写默认进行中。和进行中项目同名的行会跳过。
          </span>
          {error && <div className="t-meta c-red">{error}</div>}
        </div>
      )}
    </Modal>
  );
}
